import $ from "jquery";

$(function () {
  if (typeof hbspt === "undefined") {
    console.error("HubSpot script not loaded");
    return;
  }

  hbspt.forms.create({
    region: "na1",
    portalId: "21790357",
    target: "#hsform_share_journey",
    formId: "8278e759-ceed-4d15-947f-36e71d33fb4f",
    onFormReady: function ($form, ctx) {
        $form.find('.hs-form-field').each(function() {
            var $fieldContainer = $(this);
            var $inputField = $fieldContainer.find('input, textarea, select');
            var description = $fieldContainer.find('.hs-field-desc').text();
            
            if ($inputField.length && description) {
              $inputField.attr('placeholder', description);
            }
          });
    },
    onFormSubmit: function ($form) {
      // Prevent the default form submit action which causes the scroll to top
      $form.on('submit', function (e) {
        e.preventDefault();
        // Perform any additional actions you want here
      });
    },

    onFormSubmitted: function ($form) {
      // Prevent scrolling to the top after form submission
      $form.closest('.modal-body').scrollTop($form.closest('.hs-form').offset().top);
    }
  });
});
